<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
      <!-- <b-card-text>Profession.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Profession -->
            <b-col cols="12">
              <b-form-group label="Profession" label-for="v-profession">
                <validation-provider #default="{ errors }"  name="Profession" rules="required">
                  <b-form-input  id="v-profession-name" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Profession" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Desc -->
            <b-col cols="12">
              <b-form-group label="Desc" label-for="v-desc">
                <validation-provider #default="{ errors }" name="Desc" >
                  <b-form-input id="v-desc" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Desc" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Specialist -->
            <b-col cols="12">
              <b-form-group label="Specialist" label-for="v-specialist">
                <template v-for="(r_Specialist, index) in Specialist">
                  <b-form-checkbox v-bind:key="index" v-model="form.select_3" :value="r_Specialist.id"> {{ r_Specialist.name }} </b-form-checkbox>
                </template>
              </b-form-group>
            </b-col>
            <!-- Document -->
            <b-col cols="12">
              <b-form-group label="Specialist" label-for="v-specialist">
                <template v-for="(r_Document, index) in Document">
                  <b-form-checkbox v-bind:key="index" v-model="form.select_4" :value="r_Document.id"> {{ r_Document.name }} </b-form-checkbox>
                </template>
              </b-form-group>
            </b-col>
            <!-- Service -->
            <b-col cols="12">
              <b-form-group label="Specialist" label-for="v-specialist">
                <template v-for="(r_Service, index) in Service">
                  <b-form-checkbox v-bind:key="index" v-model="form.select_5" :value="r_Service.id"> {{ r_Service.name }} </b-form-checkbox>
                </template>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BFormCheckbox, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { BOverlay, BFormCheckbox, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, text_1: '',text_2: '',select_3: [],select_4: [],select_5: []},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ Specialist: state => state.specialist.items}),
    ...mapState({ Document: state => state.document.items}),
    ...mapState({ Service: state => state.service.items})
  },
  created () {
    this.$store.dispatch('specialist/getAll')
    this.$store.dispatch('document/getAll')
    this.$store.dispatch('service/getAll')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('profession/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('profession/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.text_2 = data.desc
        for (let is = 0, s = data.specialist.length; is < s; is++) {
          this.form.select_3.push(data.specialist[is].specialist_id) 
        }
        for (let is = 0, s = data.document.length; is < s; is++) {
          this.form.select_4.push(data.document[is].document_id) 
        }
        for (let is = 0, s = data.legalservice.length; is < s; is++) {
          this.form.select_5.push(data.legalservice[is].legal_service_id) 
        }
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>